const currentHost = window.location.host
// 测试环境，联调环境，测试环境域名
const hosts = ['192.168.3.3:8189', '192.168.3.3:8984', 'h5.xiaohebook.com', '47.114.92.155']
let prefix = hosts.find(host => {
  return currentHost.indexOf(host) > -1
})
// 如果是IP地址，并且是192.168.3开头，则默认为开发环境，否则为线上环境
if (!!prefix && currentHost.indexOf('192.168.3.3:8189') > -1) {
  prefix = 'test'
} else if (!!prefix && currentHost.indexOf('192.168.3.3:8984') > -1) {
  prefix = 'dev'
} else if (!!prefix && (currentHost.indexOf('h5.xiaohebook.com') > -1 || currentHost.indexOf('47.114.92.155') > -1)) {
  prefix = 'pro'
}
let BASE_API = ''
switch (prefix) {
  case 'dev':
    BASE_API = 'http://192.168.3.3:8984'
    break
  case 'test':
    BASE_API = 'http://192.168.3.3:8083'
    break
  case 'pro':
    BASE_API = 'https://h5.xiaohebook.com/server'
    break
  default:
    BASE_API = 'http://192.168.3.3:8083'
    break
}

const path = _path => BASE_API + _path

export const SYSTEM = {
  // 公共
  PUBLIC: {
    // 公众号签名配置
    CONFIG: path('/wx/signature'),
    // 埋点统计上报
    REPORT: path('/wxOfaRecord')
  },
  // 用户相关
  USER: {
    // 登录url
    LOGIN: path('/login')
  },
  // 活动
  ACTIVITY: {
    PAY: path('/wx/h5ActivityDetail')
  },
  // 课件
  COURSE: {
    // 轮询查询登录
    LOGIN: path('/web/ppt/scan/login'),
    // 获取登录凭证
    TICKET: path('/web/ppt/qrcode/ticket'),
    // 获取老师任教班级
    CLASS_LIST: path('/teacher/classList/v2'),
    // 课件列表
    COURSE_LIST: path('/web/ppt/list'),
    // 课程介绍
    INTRODUCE: path('/web/ppt/courseware/introduce')
  },
  // 借阅记录
  BORROWED_RECORD: {
    // 列表
    LIST: path('/open/user/borrow/log/v3')
  },
  // 获取网络电话SDK
  CLOUD_CALL_SDK_URL: path('/cloud/call/url')
}
